import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { documentService } from '@/services/documentService';
import { useAuthStore } from '@/store/authStore';
import toast from 'react-hot-toast';
import { OnlyOfficeEditor } from '@/components/ui';
import { InlineLoader } from '@/components/ui';
import { ArrowLeft, FileSpreadsheet } from 'lucide-react';

export default function ExcelEditorScreen() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuthStore();
  const [doc, setDoc] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDoc = async () => {
      try {
        setLoading(true);
        const res = await documentService.getDocument(id);
        if (res.success) setDoc(res.data);
        else {
          toast.error('Document not found');
          navigate('/documents');
        }
      } catch {
        toast.error('Failed to load document');
        navigate('/documents');
      } finally {
        setLoading(false);
      }
    };
    if (id) fetchDoc();
  }, [id, navigate]);

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-slate-50">
        <InlineLoader text="Loading document..." />
      </div>
    );
  }

  if (!doc) return null;

  return (
    <div className="fixed inset-0 flex flex-col bg-white z-[9999]">
      <div className="flex items-center justify-between px-4 py-2 border-b border-slate-200 bg-white">
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={() => {
              toast((t) => (
                <span className="flex items-center gap-2">
                  <span>Edits saved!</span>
                  <button 
                    onClick={() => { window.location.reload(); toast.dismiss(t.id); }}
                    className="text-emerald-600 font-bold underline whitespace-nowrap ml-1"
                  >
                    Click to Refresh
                  </button>
                </span>
              ), { duration: 8000, icon: '⏳', position: 'justify-center' });
              navigate('/documents');
            }}
            className="p-1.5 hover:bg-slate-100 rounded-lg text-slate-500 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
          </button>
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 bg-emerald-600 text-white rounded flex items-center justify-center">
              <FileSpreadsheet className="w-3.5 h-3.5" />
            </div>
            <h1 className="text-xs font-semibold text-slate-800">{doc.title}</h1>
          </div>
        </div>
        <span className="text-[9px] font-bold uppercase tracking-wider text-emerald-700 bg-emerald-50 px-2 py-0.5 rounded-full border border-emerald-100">
          Live Sync
        </span>
      </div>
      <div className="flex-1 overflow-hidden">
        <OnlyOfficeEditor doc={doc} user={user} documentType="cell" />
      </div>
    </div>
  );
}




